import { useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import { formatTime } from "../merchantFooter/operatingHours";
import CloseIcon from "@/components/_icons/closeIcon";
import { RegularModal } from "../modals/modals";
import { Hours } from "@/dto/hours";

interface BusinessHoursModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  daysOfWeek: string[];
  businessHours: Hours;
  timezone: string;
  isRestaurantMerchant?: boolean;
}

export const BusinessHoursModal = ({
  isOpen,
  onRequestClose,
  daysOfWeek,
  businessHours,
  timezone,
  isRestaurantMerchant,
}: BusinessHoursModalProps) => {
  const t = useTranslations("BusinessHoursModal");
  const [currentDay, setCurrentDay] = useState<string>("");
  const modalHeaderText = isRestaurantMerchant
    ? t("orderingHours")
    : t("businessHours");

  useEffect(() => {
    const today = new Date()
      .toLocaleDateString("en-US", { weekday: "long" })
      .toLowerCase();
    setCurrentDay(today);
  }, [isOpen]);

  return (
    <RegularModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="bg-opacity-75"
    >
      <div className="bg-white sm:rounded-lg shadow-lg fixed bottom-0 sm:static w-[100%] sm:h-auto sm:w-[425px] mx-auto overflow-hidden">
        <div className="flex justify-between items-center px-6 pt-6">
          <h2 className="pt-4 text-2xl leading-9 sm:text-4xl sm:text-[32px] font-medium text-[#373737]">
            {modalHeaderText}
          </h2>
          <button
            onClick={onRequestClose}
            className="text-gray-600 hover:text-gray-900"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="flex flex-col justify-center items-start py-8 px-6">
          {businessHours &&
            daysOfWeek.map((day: any) => {
              const dayHours = businessHours[day as keyof Hours] || [];
              const isCurrentDay = currentDay === day;

              return (
                <div key={day} className="flex flex-row justify-between w-full">
                  <span
                    className={`capitalize ${
                      isCurrentDay ? "font-medium" : "text-[#727272]"
                    }`}
                  >
                    {day}
                  </span>
                  <div className="flex flex-col text-end">
                    {dayHours.length > 0 ? (
                      dayHours.map((timeSlot, index) => (
                        <span
                          key={index}
                          className={`pb-4 ${
                            isCurrentDay ? "font-medium" : "text-[#727272]"
                          }`}
                        >
                          {formatTime(timeSlot.start)} -{" "}
                          {formatTime(timeSlot.end)} {timezone}
                        </span>
                      ))
                    ) : (
                      <span className="pb-4 text-[#727272]">{t("closed")}</span>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </RegularModal>
  );
};
